//get url query string params as a key value object
const getQueryString = () => {
  let a = window.location.search.substr(1).split('&');
  var b: any = {};
  for (var i = 0; i < a.length; ++i) {
    var p = a[i].split('=', 2);
    if (p.length === 1) b[p[0]] = '';
    else b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
  }
  return b;
};

export default getQueryString;
